import React, { useState, createContext } from 'react';

const StateContext = createContext();

const defaultState = {
    currentCategories: [],
    banner: null,
    /* Lists of selected { key, value } los/location options */
    currentLos: [],
    currentLocation: [],
    userLos: [],
    userLocation: [],
    actionsRequired: 3
};

export const StateProvider = ({ children, settings }) => {
    const [state, setState] = useState({
        ...defaultState,
        ...settings /* Keep defaults, but allow overwriting */
    });

    return (
        <StateContext.Provider value={{
            state,
            setState,
            updateState: properties => setState(prevState => ({
                ...prevState,
                ...properties
            }))
        }}>
            {children}
        </StateContext.Provider>
    );
};

export const StateConsumer = StateContext.Consumer;

export default StateContext;
